import { Select, Group, type SelectProps } from '@mantine/core';
import {
  IconSortAscending,
  IconSortDescending,
  IconCheck,
  IconAlignJustified,
  IconSearch,
} from '@tabler/icons-react';
import { useState } from 'react';

interface SortOption {
  value: string;
  label: string;
}

interface CellFilterSortSelectProps {
  initialValue?: string | null;
  onSubmit: (value: string | null) => void;
  placeholder?: string;
  className?: string;
}

const data: SortOption[] = [
  { value: 'asc', label: 'По возрастанию' },
  { value: 'desc', label: 'По убыванию' },
  { value: 'clear', label: 'Очистить' },
];

const iconProps = {
  stroke: 1.5,
  color: 'currentColor',
  opacity: 0.6,
  size: 18,
};

const icons: Record<string, React.ReactNode> = {
  asc: (
    <IconSortAscending
      {...iconProps}
      size={16}
      color='var(--mantine-color-primary-7)'
    />
  ),
  desc: (
    <IconSortDescending
      {...iconProps}
      size={16}
      color='var(--mantine-color-primary-7)'
    />
  ),
  clear: (
    <IconAlignJustified
      {...iconProps}
      size={16}
      color='var(--mantine-color-primary-7)'
    />
  ),
};

const RenderOption: SelectProps['renderOption'] = ({ option, checked }) => (
  <Group flex='1' gap='xs'>
    {icons[option.value]}
    {option.label}
    {checked && (
      <IconCheck style={{ marginInlineStart: 'auto' }} {...iconProps} />
    )}
  </Group>
);

export const CellTextFilterSortSelect = ({
  initialValue = null,
  onSubmit,
  placeholder = 'Фильтрация',
  className,
}: CellFilterSortSelectProps) => {
  const [value, setValue] = useState<string | null>(initialValue);
  const [searchValue, setSearchValue] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(value === 'clear' ? null : searchValue);
  };

  const handleSelectChange = (val: string | null) => {
    if (val === 'clear') {
      setValue(null);
      setSearchValue('');
      onSubmit(null);
    } else {
      setValue(val);
      onSubmit(val);
    }
    setIsDropdownOpen(false);
  };

  const handleSearchChange = (val: string) => {
    setSearchValue(val);
    // setIsDropdownOpen(true);
  };

  return (
    <form onSubmit={handleFormSubmit} className={className}>
      <Select
        value={value}
        onChange={handleSelectChange}
        placeholder={placeholder}
        data={data}
        searchable
        searchValue={searchValue}
        onSearchChange={handleSearchChange}
        leftSection={
          value ? (
            icons[value]
          ) : (
            <IconSearch
              {...iconProps}
              size={16}
              color='var(--mantine-color-primary-7)'
            />
          )
        }
        onDropdownOpen={() => setIsDropdownOpen(true)}
        onDropdownClose={() => setIsDropdownOpen(false)}
        dropdownOpened={isDropdownOpen}
        filter={({ options }) => options}
        renderOption={RenderOption}
        variant='filled'
        styles={{
          dropdown: {
            zIndex: 10000,
          },
        }}
      />
    </form>
  );
};
